<template>
    <div>
        <span v-html="$t('notification.automationRestored', {user: $_.get(activity, 'actorUser.name'), automation: $_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "AutomationRestored",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

